module.exports = __webpack_public_path__ + "img/rename.2d4b56af.svg";